module.exports = __webpack_public_path__ + "img/solution-preevision-function-icon-3.ddb07b56.svg";